/*
 * MANGO QUICK ADD - DISABLED/REMOVED
 * The user has requested to remove the Quick Add functionality but keep the visual styles.
 * This file is intentionally left empty to prevent any custom button injection.
 */
console.log('Mango Quick Add Disabled');
